module.exports = __webpack_public_path__ + "static/media/logo-white.04721450.png";